import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import intl from 'react-intl-universal';
import { OverflowMenu, OverflowMenuItem } from '@getsynapse/design-system';
import { Owner } from 'utils/customTypes';
import {
  PROJECT_PARTICIPANT_TYPE,
  RESOURCE_ALLOCATION_TABLE_SECTIONS,
  PROJECT_STATUS,
} from 'utils/constants';
import {
  setParticipantAssignmentToUpdate,
  setCurrentEditingUser,
} from 'state/ResourceAllocation/resourceAllocation';
import { useUserPermissionsContext } from 'Pages/ProjectPage/context/UserPermissionsContext';
import { getOriginalProjectData } from 'state/Project/projectSlice';

const ActionsMenu: React.FC<{
  user: Owner;
  sectionId: string;
}> = ({ user, sectionId }) => {
  const { hasUserPermissionsLevelOf } = useUserPermissionsContext();
  const isCollaboratorsSection =
    sectionId === RESOURCE_ALLOCATION_TABLE_SECTIONS.COLLABORATORS;
  const participantTypeLabel = intl.get(
    `PEOPLE.RESOURCE_ALLOCATION.TABLE.${sectionId}`,
    {
      num: 0,
    }
  );
  const dispatch = useDispatch();

  const handlePetParticipantAssignmentToUpdate = () => {
    dispatch(
      setParticipantAssignmentToUpdate({
        userId: user.id || '',
        name: `${user.data?.firstName} ${user.data?.lastName}`,
        participantType: sectionId,
      })
    );
  };

  const projectData = useSelector(getOriginalProjectData);

  const isReadOnly =
    [PROJECT_STATUS.CLOSED, PROJECT_STATUS.CANCELED].includes(
      projectData.status
    ) || projectData.is_archived;

  return (
    <div className='absolute top-0 right-0'>
      <OverflowMenu
        menuButtonProps={{ 'data-cy': `participant-${user.id}-actions-menu` }}
        menuListProps={{ 'data-cy': `participant-${user.id}-actions-list` }}
        disabled={isReadOnly}
      >
        {hasUserPermissionsLevelOf(PROJECT_PARTICIPANT_TYPE.OWNER) && (
          <OverflowMenuItem
            onSelect={handlePetParticipantAssignmentToUpdate}
            data-cy='update-assignment-option'
          >
            {intl.get('PEOPLE.RESOURCE_ALLOCATION.TABLE.UPDATE_ASSIGNMENT', {
              type: participantTypeLabel,
            })}
          </OverflowMenuItem>
        )}
        {!isCollaboratorsSection && (
          <OverflowMenuItem
            data-cy='adjust-allocation-option'
            onSelect={() =>
              dispatch(
                setCurrentEditingUser({
                  userId: user.id || '',
                  name: `${user.data?.firstName} ${user.data?.lastName}`,
                })
              )
            }
          >
            {intl.get('PEOPLE.RESOURCE_ALLOCATION.TABLE.ADJUST_ALLOCATION')}
          </OverflowMenuItem>
        )}
      </OverflowMenu>
    </div>
  );
};

export default ActionsMenu;
